import styled from "styled-components";
import TextComponent from "../../Text";
export const Text = styled(TextComponent) `
  &.isLast,
  &.hasAction:hover {
    font-weight: bold;
  }

  &.hasAction:hover {
    cursor: pointer;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JyZWFkY3J1bWJOYXZpZ2F0aW9uL3N0eWxlZC9UZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sYUFBYSxNQUFNLFlBQVksQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFBOzs7Ozs7Ozs7Q0FTeEMsQ0FBQyJ9